/**
 * @generated SignedSource<<6b146674cd4602fdb0587da74869728f>>
 * @relayHash 9a6b4598ecadd068ba328d0b73b03264
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f7b1093c6a48e06d0bb72fefb4bf08978e5f1f98aa53b64ef05a01213789c09b

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraWorkManagementFilterSearchInput = {
  contextId: string;
  favoritesOnly?: boolean | null | undefined;
  keyword?: string | null | undefined;
};
export type FiltersMenuContentQuery$variables = {
  first?: number | null | undefined;
  searchParameters: JiraWorkManagementFilterSearchInput;
};
export type FiltersMenuContentQuery$data = {
  readonly jira: {
    readonly " $fragmentSpreads": FragmentRefs<"SavedFilters_filters">;
  };
};
export type FiltersMenuContentQuery = {
  response: FiltersMenuContentQuery$data;
  variables: FiltersMenuContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchParameters"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "FiltersMenuContentQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "SavedFilters_filters"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "FiltersMenuContentQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "first",
                "variableName": "first"
              },
              {
                "kind": "Variable",
                "name": "searchParameters",
                "variableName": "searchParameters"
              }
            ],
            "kind": "LinkedField",
            "name": "jwmFilters",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "JiraWorkManagementFilterEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraWorkManagementFilter",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "id"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "name"
                          }
                        ]
                      }
                    ]
                  }
                ],
                "type": "JiraWorkManagementFilterConnection"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "message"
                  }
                ],
                "type": "QueryError"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "f7b1093c6a48e06d0bb72fefb4bf08978e5f1f98aa53b64ef05a01213789c09b",
    "metadata": {},
    "name": "FiltersMenuContentQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "2dcdcd62ddfa117c0a0a2a4b16ac5aa0";

export default node;
